const skeleton1 = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='620'
		height='390'
		viewBox='0 0 620 390'>
		<defs>
			<clipPath id='clip-Artboard_1'>
				<rect
					width='620'
					height='390'
				/>
			</clipPath>
		</defs>
		<g
			id='Artboard_1'
			data-name='Artboard – 1'
			clipPath='url(#clip-Artboard_1)'>
			<rect
				width='620'
				height='390'
				fill='#292929'
			/>
			<path
				id='Path_15852'
				data-name='Path 15852'
				d='M677.263,428.679,516.9,10.061a5.556,5.556,0,0,0-4.981-3.7L152.342,0a5.112,5.112,0,0,0-4.869,3.524L0,416.7S678.721,432.487,677.263,428.679Z'
				transform='translate(486.541 480.783) rotate(-173)'
				stroke='#292929'
				strokeWidth='1'
			/>
			<g
				id='Path_15855'
				data-name='Path 15855'
				fill='none'>
				<path
					d='M0,0H620V390H0Z'
					stroke='none'
				/>
				<path
					d='M 3 3 L 3 387 L 617 387 L 617 3 L 3 3 M 0 0 L 620 0 L 620 390 L 0 390 L 0 0 Z'
					stroke='none'
					fill='#292929'
				/>
			</g>
		</g>
	</svg>
);

const skeleton2 = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='620'
		height='390'
		viewBox='0 0 620 390'>
		<defs>
			<clipPath id='clip-Artboard_3'>
				<rect
					width='620'
					height='390'
				/>
			</clipPath>
		</defs>
		<g
			id='Artboard_3'
			data-name='Artboard – 3'
			clipPath='url(#clip-Artboard_3)'>
			<rect
				width='620'
				height='390'
				fill='#292929'
			/>
			<g
				id='Path_15853'
				data-name='Path 15853'
				fill='none'>
				<path
					d='M0,0H620V390H0Z'
					stroke='none'
				/>
				<path
					d='M 2 2 L 2 388 L 618 388 L 618 2 L 2 2 M 0 0 L 620 0 L 620 390 L 0 390 L 0 0 Z'
					stroke='none'
					fill='#292929'
				/>
			</g>
			<path
				id='Path_15856'
				data-name='Path 15856'
				d='M268.63.12c148.8.491,269.834,126.4,270.341,281.234S419.264,561.3,270.466,560.812.632,434.408.125,279.578,119.832-.37,268.63.12Z'
				transform='translate(241.538 -166.018) rotate(22)'
			/>
			<g
				id='Path_15854'
				data-name='Path 15854'
				fill='none'>
				<path
					d='M0,0H620V390H0Z'
					stroke='none'
				/>
				<path
					d='M 3 3 L 3 387 L 617 387 L 617 3 L 3 3 M 0 0 L 620 0 L 620 390 L 0 390 L 0 0 Z'
					stroke='none'
					fill='#292929'
				/>
			</g>
		</g>
	</svg>
);

const skeleton3 = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='620'
		height='390'
		viewBox='0 0 620 390'>
		<defs>
			<clipPath id='clip-Artboard_2'>
				<rect
					width='620'
					height='390'
				/>
			</clipPath>
		</defs>
		<g
			id='Artboard_2'
			data-name='Artboard – 2'
			clipPath='url(#clip-Artboard_2)'>
			<rect
				width='620'
				height='390'
				fill='#292929'
			/>
			<path
				id='Path_10507'
				data-name='Path 10507'
				d='M0,0H434.347c0,303.5-194.471,549.562-434.347,549.562H0Z'
				transform='matrix(0.174, 0.985, -0.985, 0.174, 505.79, -14)'
			/>
			<g
				id='Path_15853'
				data-name='Path 15853'
				fill='none'>
				<path
					d='M0,0H620V390H0Z'
					stroke='none'
				/>
				<path
					d='M 2 2 L 2 388 L 618 388 L 618 2 L 2 2 M 0 0 L 620 0 L 620 390 L 0 390 L 0 0 Z'
					stroke='none'
					fill='#292929'
				/>
			</g>
			<g
				id='Path_15854'
				data-name='Path 15854'
				fill='none'>
				<path
					d='M0,0H620V390H0Z'
					stroke='none'
				/>
				<path
					d='M 3 3 L 3 387 L 617 387 L 617 3 L 3 3 M 0 0 L 620 0 L 620 390 L 0 390 L 0 0 Z'
					stroke='none'
					fill='#292929'
				/>
			</g>
		</g>
	</svg>
);

const skeleton4 = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='620'
		height='390'
		viewBox='0 0 620 390'>
		<defs>
			<clipPath id='clip-Artboard_4'>
				<rect
					width='620'
					height='390'
				/>
			</clipPath>
		</defs>
		<g
			id='Artboard_4'
			data-name='Artboard – 4'
			clipPath='url(#clip-Artboard_4)'>
			<rect
				width='620'
				height='390'
				fill='#292929'
			/>
			<path
				id='Path_15857'
				data-name='Path 15857'
				d='M0,0H434.347c0,303.5-194.471,549.562-434.347,549.562H0Z'
				transform='matrix(0.174, 0.985, -0.985, 0.174, 507.79, 0)'
			/>
			<g
				id='Path_15855'
				data-name='Path 15855'
				fill='none'>
				<path
					d='M0,0H620V390H0Z'
					stroke='none'
				/>
				<path
					d='M 3 3 L 3 387 L 617 387 L 617 3 L 3 3 M 0 0 L 620 0 L 620 390 L 0 390 L 0 0 Z'
					stroke='none'
					fill='#292929'
				/>
			</g>
		</g>
	</svg>
);

const skeleton5 = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='1638'
		height='638'
		viewBox='0 0 1638 638'>
		<g
			id='Group_22160'
			data-name='Group 22160'
			transform='translate(-141 -4552)'>
			<rect
				id='Rectangle_2392'
				data-name='Rectangle 2392'
				width='135'
				height='33'
				rx='2'
				transform='translate(1644 4775)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2394'
				data-name='Rectangle 2394'
				width='135'
				height='33'
				rx='2'
				transform='translate(1644 4934)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2395'
				data-name='Rectangle 2395'
				width='135'
				height='33'
				rx='2'
				transform='translate(1644 5093)'
				fill='#f0f0f0'
			/>
			<line
				id='Line_152'
				data-name='Line 152'
				x2='1638'
				transform='translate(141 4871)'
				fill='none'
				stroke='#ececec'
				strokeWidth='2'
			/>
			<line
				id='Line_153'
				data-name='Line 153'
				x2='1638'
				transform='translate(141 5030)'
				fill='none'
				stroke='#ececec'
				strokeWidth='2'
			/>
			<line
				id='Line_268'
				data-name='Line 268'
				x2='1638'
				transform='translate(141 5189)'
				fill='none'
				stroke='#ececec'
				strokeWidth='2'
			/>

			<g
				id='Group_21802'
				data-name='Group 21802'
				transform='translate(0 118)'>
				<g
					id='Group_21220'
					data-name='Group 21220'
					transform='translate(0 -2088)'></g>
			</g>
			<g
				id='Group_21804'
				data-name='Group 21804'
				transform='translate(0 118)'>
				<g
					id='Group_21223'
					data-name='Group 21223'
					transform='translate(0 -2082.002)'></g>
			</g>
			<rect
				id='Rectangle_2376'
				data-name='Rectangle 2376'
				width='302'
				height='51'
				rx='2'
				transform='translate(141 4925)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2396'
				data-name='Rectangle 2396'
				width='302'
				height='51'
				rx='2'
				transform='translate(141 5084)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2377'
				data-name='Rectangle 2377'
				width='302'
				height='51'
				rx='2'
				transform='translate(141 4766)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2380'
				data-name='Rectangle 2380'
				width='302'
				height='33'
				rx='2'
				transform='translate(642 4775)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2381'
				data-name='Rectangle 2381'
				width='302'
				height='33'
				rx='2'
				transform='translate(642 4934)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2382'
				data-name='Rectangle 2382'
				width='302'
				height='33'
				rx='2'
				transform='translate(642 5093)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2383'
				data-name='Rectangle 2383'
				width='56'
				height='33'
				rx='2'
				transform='translate(1183 5093)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2391'
				data-name='Rectangle 2391'
				width='302'
				height='33'
				rx='2'
				transform='translate(1310 5093)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2385'
				data-name='Rectangle 2385'
				width='56'
				height='33'
				rx='2'
				transform='translate(1183 4934)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2390'
				data-name='Rectangle 2390'
				width='302'
				height='33'
				rx='2'
				transform='translate(1310 4934)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2386'
				data-name='Rectangle 2386'
				width='56'
				height='33'
				rx='2'
				transform='translate(1183 4775)'
				fill='#f0f0f0'
			/>
			<rect
				id='Rectangle_2388'
				data-name='Rectangle 2388'
				width='302'
				height='33'
				rx='2'
				transform='translate(1310 4775)'
				fill='#f0f0f0'
			/>
			<g
				id='Group_22159'
				data-name='Group 22159'>
				<line
					id='Line_151'
					data-name='Line 151'
					x2='1638'
					transform='translate(141 4712)'
					fill='none'
					stroke='#ececec'
					strokeWidth='2'
				/>
				<line
					id='Line_267'
					data-name='Line 267'
					x2='1638'
					transform='translate(141 4553)'
					fill='none'
					stroke='#ececec'
					strokeWidth='2'
				/>
				<g
					id='Group_22155'
					data-name='Group 22155'>
					<rect
						id='Rectangle_2393'
						data-name='Rectangle 2393'
						width='135'
						height='33'
						rx='2'
						transform='translate(1644 4616)'
						fill='#f0f0f0'
					/>
					<rect
						id='Rectangle_2378'
						data-name='Rectangle 2378'
						width='302'
						height='51'
						rx='2'
						transform='translate(141 4607)'
						fill='#f0f0f0'
					/>
					<rect
						id='Rectangle_2379'
						data-name='Rectangle 2379'
						width='302'
						height='33'
						rx='2'
						transform='translate(642 4616)'
						fill='#f0f0f0'
					/>
					<rect
						id='Rectangle_2387'
						data-name='Rectangle 2387'
						width='56'
						height='33'
						rx='2'
						transform='translate(1183 4616)'
						fill='#f0f0f0'
					/>
					<rect
						id='Rectangle_2389'
						data-name='Rectangle 2389'
						width='302'
						height='33'
						rx='2'
						transform='translate(1310 4616)'
						fill='#f0f0f0'
					/>
				</g>
			</g>
		</g>
	</svg>
);

export { skeleton1, skeleton2, skeleton3, skeleton4, skeleton5 };
